/* global google:false */
/* global preloader:false */
/* global PhotoSwipe:false */
/* global PhotoSwipeUI_Default:false */

window.bpLarge = 1280;
window.bpIPadMax = 1024;
window.bpMedium = 960;
window.bpIPadMin = 768;
window.bpSmall = 640;
window.bsLGB = 992;

/**
 * breakpoints
 */
window.width = $(window).width();
window.windowInnerWidth = window.innerWidth || $(window).width();
window.windowInnerHeight = window.innerHeight || $(window).height();

if (window.width !== window.windowInnerWidth) {
    window.scrollBar = true;
}

/**
 * Use it if you want to render some function or plugin or variable in certain page.
 * If you want to use on more than one use the page and logical OR (||) in JavaScript eg. "page.simple || page.room"
 *
 * If page object is inside document.ready it is not visible outside of it.
 * */
const page = {};
const $body = $(document.body);

page.all =          true; // Pass on every page
page.home =         $body.hasClass('home');
page.simpleList =   $body.hasClass('page-template-simple-list');
page.simple =       $body.hasClass('page-template-simple');
page.roomList =     $body.hasClass('page-template-rooms');
page.room =         $body.hasClass('single-room');
page.photoGallery = $body.hasClass('page-template-gallery');
page.loyalty =      $body.hasClass('page-template-loyalty');
page.location =     $body.hasClass('page-template-location');
page.contact =      $body.hasClass('page-template-contact');

$(document).ready( ($) => {

    // Internet Explorer IE11
    if (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > -1) {
        $body.addClass('trash-browser');
    }

    pushBody();

    // CONNECT MENU BTN WITH MENU-PRIMARY
    $('html').connector({
        connector: '.menu-connector',
        toggleClassName: 'menu-active'
    });

    // ADD SCROLLED CLASS AFTER SCROLL ON BODY
    $body.scroller({
        classToggle: 'scrolled',
        // breakpoint: window.width > window.bpLarge,
        tilt: 1,
        revert: true
    });

    // ADD SCROLLED CLASS AFTER SCROLL ON BODY
    $body.scroller({
        element: '.move-up',
        tilt: -95,
        revert: false,
        page: page.home
    });

    // FANCY MESSAGE ANIMATION
    $body.scroller({
        element: '#fancy-message',
        classToggle: 'run-anime',
        tilt: -95,
        revert: false,
        page: page.home
    });

    $('#home-experiences').scroller({
        element: '.move-up-items',
        breakpoint: window.width > window.bpLarge,
        tilt: -90,
        revert: false,
        page: page.home
    });

    // ADD CUSTOM ARROWS ON HOME-ROOMS SLIDER
    $('#home-rooms').find('.left-side-items').customArrow({
        previous: '#room-prev',
        next:     '#room-next',
        minSlides: 1,
        slide:     '.room-image'
    });

    // COLLAGE SLIDER ON MOBILE
    if ( window.width < window.bsLGB ) {
        $('#home-experiences').find('.experience-items').flickity({
            // options
            wrapAround: false,
            contain: false,
            pageDots: false
        });
    }

    // ADD CUSTOM ARROWS ON REVIEWS SLIDER
    $('#home-reviews').find('.reviews-items').customArrow({
        previous: '#review-prev',
        next:     '#review-next',
        minSlides: 1,
        slide:     '.flickity-slide'
    });

    pointAppear();

    masonryGallery();


    readMore();

    // PROMO SECTION SLIDER
    if ( !page.home || !page.room ) {

        const $promoSection = $('#promo-section');
        if ($promoSection) {

            const $promoItems = $promoSection.find('.promo-items');

            if ($promoSection.find('.promo-item').length > 3) {

                $promoItems.flickity({
                    cellSelector: '.promo-item',
                    pageDots: false,
                    wrapAround: true
                });
            } else if (window.width < window.bpLarge && $promoSection.find('.promo-item').length > 2) {

                $promoItems.flickity({
                    cellSelector: '.promo-item',
                    pageDots: false,
                    wrapAround: true
                });

            }
        }
    }

});

$(window).on('load', () => {

    $('html').anchorScroll({
        triggerElement: '.hero-arrow-down'
    });

    if ( page.room ) {

        let $roomGallery = $('#room-gallery');
        $roomGallery.photoswipeLightbox( $roomGallery.data('photoswipe-options') );

    }

});

function readMore() {

    const $contact_directions = $('#contact-directions'),
        $content        = $contact_directions.find('.contact-directions-body'),
        $readMoreButton = $contact_directions.find('.read-more-button'),
        closedText      = $contact_directions.data('closed-text'),
        openText        = $readMoreButton.find('.button-text').text();

    $content.css({
        'max-height': 360
    });

    $contact_directions.find('.read-more-button').on('click', function(e) {

        if ( $contact_directions.hasClass('toggled') ) {
            $content.css({
                'max-height': 360
            });
            $readMoreButton.find('.button-text').text(openText);

        } else {
            $content.css({
                "max-height": '100%'
            });
            $readMoreButton.find('.button-text').text(closedText);
        }

        $contact_directions.toggleClass('toggled');

        e.preventDefault();
    });
}


// Push the body if the header is fixed positioned with solid color.
function pushBody() {
    // Get the header height
    const headerHeight = $('#main-header').height();

    // Adding it as a hero's padding
    $body.css({
        'padding-top': headerHeight
    });
}


/**
 * Masonry Gallery
 */
function masonryGallery() {

    if ( page.photoGallery ) {

        let $gallery = $("#masonry-gallery");
        if ($gallery.length > 0) {

            if ($gallery.data("isotope")) {
                /**
                 * init Isotope after all images have loaded
                 */
                $gallery.imagesLoaded().progress(function () {

                    $gallery.isotope('layout');
                });

                /**
                 * Filter items on button click
                 */
                $(".masonry-gallery-filters").on("click", "li a", function () {
					if (typeof preloader === 'function') {
						$gallery.find('.gallery-item').preloader({
							loader: '/app/themes/nelios-base/svg/loader/preloader.svg',
							fadeIn: 300,
							delay: 100
						});
					}

                    $gallery.isotope({
                        filter: $(this).attr("data-filter")
                    });
                });
            } else if ($gallery.data("masonry")) {
                $gallery.imagesLoaded().progress(function () {
                    $gallery.masonry('layout');
                });
            }

            $gallery.photoswipeLightbox($gallery.data('photoswipe-options'));

        }

    }
}

function pointAppear() {

    if ( page.location && window.width >= window.bpIPadMin) {
        // $(window).on('resize', function() {
        //     location.reload();
        // });
        var $mapWrapper = $('#map-section'),
            $points = $('#points'),
            $backgroundImages = $('#background-images'),
            $pointTooltips = $('#point-tooltips'),
            images = $backgroundImages.find('.background-image'),
            points = $points.find('.point'),
            pointTooltips = $pointTooltips.find('.point-tooltip');


        $points.find('.point').each( function() {

            let left = $(this).offset().left,
                leftPercent = left / window.width * 100;

            $(this).find('.point-tooltip').css({
                '-webkit-transform' : 'translate(-'+leftPercent+'%, 2em)',
                'transform' : 'translate(-'+leftPercent+'%, 2em)',
            });
        });

        $points.find('.point').on('mouseenter touchstart', function(element) {

            let dataPin = $(this).data('pin');

            $.each(points, function(index, el) {
                if (index === dataPin) {
                    $(el).addClass('active');

                    $mapWrapper.addClass('active-point');
                }
            });

            $(this).on('mouseleave touchend', function(en) {
                    $points.find('.active').removeClass('active');
            });
        });
    }
}

// Observe the scroll and add classes where needs
$.fn.scroller = function (options) {

    const opt = $.extend(
        {
            founder: this,          // Founder is the wrapper, if 'element' is empty it will watching this element
            element: '',            // The app watching this element
            page: true,             // If you want to render on certain pages include 'em from the page object
            // offset: 1,              // 1 = enter, 0.5 = center, 0 = leave
            tilt: 5,                // The distance in percentage that the element will be triggered
            classToggle: 'revealed',
            breakpoint: true,
            revert: false
        },
        options
    );

    const tiltHeight = opt.tilt === 0 ? 0 : (window.innerHeight / 100) * opt.tilt;

    const app = {

        init: () => {

            // if this page is true and if this breakpoint is true
            if ( opt.page && opt.breakpoint ) {

                if ( opt.element ) {
                    app.loop( opt.element );
                } else {
                    app.loop( opt.founder );
                }
            }

        },

        loop: (loopElement) => {

            $(loopElement).each( function(i, el) {

                app.action( $(this) );

            });
        },

        action: ( $currentItem ) => {

            // Runs at first time
            app.toggleClass( $currentItem );

            // Runs on scroll
            document.addEventListener('scroll', () => app.toggleClass( $currentItem ) );

        },

        toggleClass: ( $currentItem ) => {

            window.requestAnimationFrame(function() {

                if ( $currentItem.offset().top + tiltHeight <= app.getCurrentScroll()) {

                    if ( $currentItem.not(opt.classToggle)) {

                        // Add class that has been set
                        $currentItem.addClass(opt.classToggle);

                        // If opt.revert is set to false then event scroll will be removed
                        if ( !opt.revert ) {

                            document.removeEventListener('scroll', () => app.toggleClass( $currentItem ) );

                        }

                    }

                } else {

                    // Remove class
                    if ($currentItem.hasClass(opt.classToggle)) {

                        $currentItem.removeClass(opt.classToggle);

                    }

                }

            });

        },

        getCurrentScroll: () => {
            return window.pageYOffset || document.documentElement.scrollTop;
        }

    };

    app.init();

};

/** Make connection between two or more elements
 *
 * 1. Include '.connector' class on html elements that you want to be trigger the connected elements
 * (a*)
 *
 * 2. Include 'data-connector="connector"' attribute on all HTML elements that will be connected together
 * (a*)
 *
 * a* .You can change the default name to another eg. '.menu-connector'.
 *    .It is preferred if Connector plugin calls more than once.
 *
 * @param options
 *
 * founder: this,              // The initial items, must be wrap all of the connectors
 * connector: '.connector',    // The trigger
 * removeSiblings: false,      // If siblings exist, remove 'active' class from them,
 * triggerType:                // You can choose between 'click' and 'mouseover'. The other events are not tested.
 * toggleClassName: 'active'   // You can add your className.
 *
 */
$.fn.connector = function (options) {

    const opt = $.extend({
        founder: this,
        connector: '.connector',
        removeSiblings: false,
        triggerType: 'click',
        toggleClassName: 'active',
        atLeastOneEnabled: false,
        breakpoint: true,
        page: true,
    }, options);

    const app = {

        init: () => {

            // Check if meets the page and the breakpoint
            if ( opt.page && opt.breakpoint && opt.founder.length ) {
                app.action();
            }

        },

        action: () => {

            // opt.founder.each((i, el) => {

            opt.connector = opt.founder.find(opt.connector);

            // If connector exists
            if ( opt.connector ) {

                // On triggerType (use click or mouse over)
                opt.connector.on( opt.triggerType, (e) => {

                    app.activate(e.currentTarget);

                    const href = $(e.currentTarget).attr('href');

                    // Prevent from moving to top if the current attribute is #
                    if ( href === '#' ) {
                        e.preventDefault();
                    }

                });
            }

            // });

        },

        activate: (target) => {

            // Get the connector data attribute
            const data_connector = $(target).data('connector');

            // If removeSiblings is activated
            if ( opt.removeSiblings ) {

                // Remove siblings of each item and all it relatives
                opt.founder.find('[data-connector=' + data_connector + ']').siblings().removeClass(opt.toggleClassName);

            }

            // On data-connectors with certain name, toggle-class
            opt.founder.find('[data-connector=' + data_connector + ']').toggleClass( opt.toggleClassName );

        },
    };

    app.init();

};


/** Smooth scroll on anchor links
 *
 * 1. Add '.scroll-down' class on <a> elements that you want to be trigger
 * (a*)
 *
 * 2. Init the plugin on $(document).on('ready') or $(window).on('load')
 *
 * a* .You can change the default name to another eg. '.hero-scroll-down'.
 *
 * @param options
 *
 * founder: this,                   // Object:  The initial item, should be wrap all of the trigger anchors (.scroll-down)
 * triggerElement: '.scroll-down'   // String:  The trigger
 * headerId: ''                     // String:  If you add header id eg '#main-header', it get the height of it and remove it
 *                                              from the animation so as not to hide the section behind the header
 * speed:                           // Number:  A speed number on ms eg. 500ms
 * breakpoint:                      // Boolean: Eg. window.width > 1024
 * page:                            // Boolean: If you add sth like $(body).hasClass('home'); will be runs only on homepage
 *                                              you can also you the page.home from custom page object
 *
 */
$.fn.anchorScroll = function (options) {

    const opt = $.extend(
        {
            founder: this,
            triggerElement: '.scroll-down',
            headerId: '#main-header',
            speed: 500,
            breakpoint: true,
            page: true,
        },
        options );

    const app = {

        init: () => {

            if ( opt.page && opt.breakpoint ) {
                app.action();
            }

        },

        action: () => {

            $( opt.triggerElement).on({
                'click': () => {

                    const anchoredItemId = $( opt.triggerElement ).attr('href');
                    const anchoredItemDistance = $( anchoredItemId ).offset().top;
                    const headerHeight = $( opt.headerId ).height();


                    $( 'html' ).animate({
                        scrollTop: anchoredItemDistance - headerHeight
                    }, opt.speed );

                    return false;
                }
            });

        },

    };

    app.init();
};

/** Add custom arrows for flickity
 *
 * @param options
 *
 * 1. Create in PHP 2 arrows with unique ID each, eg.
 *
 *    <div id="custom-previous'> PREVIOUS </div> and
 *    <div id="custom-next'> NEXT </div> for next
 *
 *    inside these elements you can add whatever you want like SVG arrows or text
 *
 * 2. Initialize plugin on slider element and define next and previous buttons eg.
 *
 *    $('#hero').customArrows({
 *      'previous': '#hero-previous'
 *      'next': '#hero-next'
 *    )};
 *
 *
 */
$.fn.customArrow = function ( options ) {

    const opt = $.extend({
        founder:    this,
        slide:      '.flickity-slide',
        previous:   '',
        next:       '',
        minSlides:  3,
        breakpoint: true,
        page:       true
    }, options);


    const app = {
        init: () => {

            if ( opt.page && opt.breakpoint && opt.founder.length && opt.minSlides <= app.slidesCount() ) {
                app.bindArrow( $(opt.previous), 'previous' );
                app.bindArrow( $(opt.next), 'next' );
            }

        },

        slidesCount: () => {
            const items = opt.founder.find(opt.slide);
            return items.length;
        },

        bindArrow: ( $button, direction ) => {

            $button.on('click', () => {

                console.log('pass3');

                opt.founder.flickity( direction );
            });

            app.showCustomArrow( $button );

        },

        showCustomArrow: ( $button ) => {

            $button.css({
                'visibility': 'visible',
                'pointer-events': 'auto'
            });

        }
    };

    app.init();
};

/**
 * Photoswipe Lightbox
 *
 * @param options
 */
$.fn.photoswipeLightbox = function(options) {
    var el = $(this);

    var settings = $.extend({
        closeOnScroll: true,
        escKey: true,
        arrowKeys: true,
        loop: true,
        history: true,
        focus: true,
        modal: true,
        showHideOpacity: true,
        closeEl: true,
        captionEl: true,
        fullscreenEl: true,
        zoomEl: true,
        shareEl: true,
        counterEl: true,
        arrowEl: true,
        preloaderEl: true,
        bgOpacity: 0.7,
    }, options);

    el.each( function() {
        var $pic     = $(this),
            getItems = function() {
                var items = [];
                $pic.find("a").each(function() {
                    var item = {
                        src : $(this).data("src"),
                        w   : $(this).data("width"),
                        h   : $(this).data("height"),
                        msrc   : $(this).find("img").attr("src"),
                        title   : $(this).data("title"),
                        pid   : $(this).data("slug"),
                    };

                    items.push(item);
                });
                return items;
            };

        var items = getItems();

        var $pswp = $(".pswp")[0];
        $pic.on("click", "a", function(event) {
            event.preventDefault();

            var $index = $(this).data("index");
            var options = {
                index: $index,
                bgOpacity: settings.bgOpacity,
                spacing: 0.12,
                allowPanToNext: true,
                pinchToClose: true,
                closeOnScroll: settings.closeOnScroll,
                closeOnVerticalDrag: true,
                escKey: settings.escKey,
                arrowKeys: settings.arrowKeys,
                history: settings.history,
                mouseUsed: false,
                loop: settings.loop,
                focus: settings.focus,
                modal: settings.modal,
                showHideOpacity: settings.showHideOpacity,
                showAnimationDuration: 333,
                hideAnimationDuration: 333,
                closeEl: settings.closeEl,
                captionEl: settings.captionEl,
                fullscreenEl: settings.fullscreenEl,
                zoomEl:  settings.zoomEl,
                shareEl:  settings.shareEl,
                counterEl: settings.counterEl,
                arrowEl: settings.arrowEl,
                preloaderEl:  settings.preloaderEl,
            };

            // Initialize PhotoSwipe
            var lightBox = new PhotoSwipe($pswp, PhotoSwipeUI_Default, items, options);
            lightBox.init();
        });
    });
};

(function($) {
	$(document).ready(function() {
		$('.filter-tab-link').on('click', function(e) {
			e.preventDefault();
			var filter = $(this).data('filter');
			$('#masonry-gallery').isotope({ filter: filter });
			$('.filter-tab-link').removeClass('active');
			$(this).addClass('active');
		});
	});
})(jQuery);

document.addEventListener('DOMContentLoaded', function() {
	var pageUrl = window.location.href.indexOf("the-hotel");
	if (pageUrl !== -1) {
		var footer = document.querySelector('.content-page-footer');
		if (footer) {
			footer.classList.remove('d-flex');
			footer.classList.add('d-none');
		}
	}
});

